<style lang="less">
    .page_con.redo {
        height:100vh;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }
    .redo .art_content{
        width:100%;
        overflow: hidden;
        position: relative;
        flex:1;
        // padding:.6rem 0 0;
        // display: flex;
        // flex-direction: column;
        // align-items: center;
        // justify-content: center;
        .pd{
            width:100%;
            flex:1;
            margin-top:.6rem;
            padding: 0 .2rem;
        }
        .art_bottom{
            width:100%;
            height:auto;
            position: relative;
            img.art_bottom_bg{
                width:100%;
                height:auto;
                display: block;
            }
            img.art_bottom_flowers{
                width:1.2rem;
                height:auto;
                display: block;
                position: absolute;
                left: .3rem;
                bottom:0;
                z-index: 11;
            }
            img.art_bottom_sunflowers{
                width:1.8rem;
                height:auto;
                display: block;
                position: absolute;
                right: 0rem;
                bottom:.1rem;
                z-index: 11;
            }
        }
    }
    .redo .art_title{
        width:100%;
        height:1.3rem;
        font-size: .46rem;
        text-shadow:0px 2px 2px rgba(0, 0, 0, 0.5);
        color:#fff;
        position: absolute;
        left:0;
        top:0;
        z-index: 11;
        display: flex;
        align-items: center;
        justify-content: center;
        background:url("../assets/images/title-pc.png") no-repeat;
        background-position: center;
        background-size: auto 100%;
        span{
            padding-bottom: .2rem;
        }
    }
    .redo .art_text_con{
        width:100%;
        height:auto;
        background: #78D3FF;
        border:2px solid #1D2088;
        box-shadow:0px .08rem .02rem 0px rgba(0, 0, 0, 0.3);
        border-radius: .1rem;
        padding:.9rem .2rem .2rem;
        >img{
            width:100%;
            height:auto;
            display: block;
        }
        .art_inner{
            width:100%;
            height:60vh;
            background:#FFFDE4;
            // border-radius: .15rem;
            padding:.2rem;
            display: flex;
            flex-direction: column;
            >div{
                width:100%;
                height:100%;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                >img{
                    width:100%;
                    height:auto;
                    display: block;
                    margin-bottom: .4rem;
                }
            }
        }
        .art_btns{
            width:100%;
            padding:0 .2rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: .4rem;
            .btns_left{
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .art_btn{
                width:1.6rem;
                height:.8rem;
                margin-right:.2rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: .32rem;
                color:#fff;
                background:url("../assets/images/button2language-phone.png") no-repeat;
                background-size: 100% 100%;
                >span{
                    margin-bottom: .1rem;
                }
            }
            .art_btn.active{
                background-image:url("../assets/images/button1language-phone.png");
            }
            .art_refresh{
                width:1rem;
                height:.8rem;
                img{
                    width:100%;
                    height:auto;
                    display: block;
                }
            }
        }
    }
    .redo .art_video_con{
        width:100%;
        padding:0 .2rem;
        video{
            width:100%;
            height:auto;
        }
    }
    .select_con{
        width:5.95rem;
        margin:0 auto .2rem;
        padding:0 .2rem;
    }
    .list_room{
        width:100%;
        flex:1;
        overflow-x: hidden;
        overflow-y: auto;
        li{
            width:100%;
            height:1.8rem;
            border-radius: .1rem;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-size: .3rem;
            font-weight: bold;
            margin-bottom: .1rem;
        }
    }
    .item_left{
        width:1rem;
        height:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(146,190,55,.2);
        margin-right:.04rem;
    }
    .item_right{
        flex:1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height:100%;
        padding:.25rem .15rem .25rem .4rem;
        background: rgba(146,190,55,.2);
        .title,.game{
            width:100%;
            padding:.08rem 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .btn_redo{
            width:1rem;
            height:.56rem;
            padding-bottom: .08rem;
            background: url("../assets/images/button7.png") no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color:#fff;
            font-size: .28rem;
            font-weight: bold;
            text-shadow:0px 1px 1px rgba(0, 0, 0, 1);
        }
    }
</style>
<template>
    <div class="page_con redo">
        <div class="all_top">
            <div class="btnBack" @click="$router.go(-1)"></div>
            <div class="btnHome" @click="$router.push('/index')"></div>
        </div>
        <div class="art_content">
            <div class="pd">
                <div class="art_title">
                    <span>再來一次</span>
                </div>
                <div class="art_text_con"><!-- 蓝底 padding -->
                    <img src="../assets/images/up-article-phone.png" alt="">
                    <div class="art_inner"><!-- 黄底 padding -->
                        <div>
                            <div class="select_con">
                                <selectdown v-if="list.length" :list="list" :width="'3rem'" :height="'.9rem'" :type="'yellow'" @change="choice"></selectdown>
                            </div>
                            <ul class="list_room">
                                <li class="item" v-for="(item,index) in data" :key="index">
                                    <div class="item_left">{{item.push_date.substring(item.push_date.length,item.push_date.length-2)}}</div>
                                    <div class="item_right">
                                        <div class="title">
                                            <span>{{item.article_title}}</span>
                                            <router-link :to="{path:'/artical',query:{pushdate:item.push_date}}" class="btn_redo">補讀</router-link>
                                        </div>
                                        <div class="game">
                                            <span v-for="(name,idx) in games[item.article_id]" :key="idx">{{name}}</span>
                                            <router-link :to="{path:'/play',query:{pushdate:item.push_date}}" class="btn_redo">{{item.game_redo==2?"補做":"重玩"}}</router-link>
                                        </div>
                                    </div>
                                </li>
                                <!-- <li class="item">
                                    <div class="item_left">10</div>
                                    <div class="item_right">
                                        <div class="title">
                                            <span>吹泡泡</span>
                                            <div class="btn_redo">補做</div>
                                        </div>
                                        <div class="game">
                                            <span>找一找</span>
                                            <span>寫一寫</span>
                                            <span>答一答</span>
                                            <div class="btn_redo">重玩</div>
                                        </div>
                                    </div>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                    <img src="../assets/images/down-article-phone.png" alt="">
                </div>
            </div>
            <div class="art_bottom">
                <img class="art_bottom_bg" src="../assets/images/bg3-phone.png" alt="">
                <img class="art_bottom_flowers" src="../assets/images/flowers.gif" alt="">
                <img class="art_bottom_sunflowers" src="../assets/images/sunflower.gif" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import selectdown from './selectdown'
export default {
    components:{
        selectdown
    },
    data(){
        return {
            list:[],
            data:[],
            games:{},
        }
    },
    mounted(){
        this.initDate();
    },
    methods:{
        choice(val){
            console.log(val)
            this.getData(val.value.substring(0,7));
        },
        getData(date){
            let vm = this;
            vm.$http.get(this.baseUrl+"/Game/more.html?rest_key=1&date="+date).then(res=>{
                console.log(77777);
                if(res.data.code == 1){
                    vm.games = res.data.data.ArticleGame;
                    vm.data = res.data.data.list;
                }
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/redo.vue